import LoginControllerBase from "../LoginControllerBase";

class LoginLeadManagerController extends LoginControllerBase {
  constructor($location, $state, $stateParams, authService, appConfig, pushService, angularAuth0, enums) {
    "ngInject";

    super($location, $state, $stateParams, authService, appConfig, pushService, angularAuth0, enums);

    this.sections = [
      {name: 'Home', visible: true, text: 'Welcome to Lead Manager ... Europes #1 Lead Management Tool', bgClass: 'bg1'},
      {name: 'What We Do', visible: false, text: 'Capture measure & manage every lead regardless of source', bgClass: 'bg2'},
      {name: 'Contact Us', visible: false, text: 'Understand the best source of leads for your business', bgClass: 'bg3'}
    ];
    
    this.selectedSection = this.sections[0];

    this.initialize();
  }

  updateSection(index) {
    this.sections.map(s => s.visible = false);
    this.selectedSection = this.sections[index];
    this.selectedSection.visible = true;
  }
}

export default LoginLeadManagerController;



// WEBPACK FOOTER //
// ./client/app/components/login/loginLeadManager/loginLeadManager.controller.js